import React from "react";
import "./sponsorship.component.css";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";


const SponsorshipTable = () => {

    return (
        <>
            <Helmet>
                <title>ABOUT US SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
                <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <HeaderComponent />
            <NavbarComponent />
            <section id="fixed-sub-nav" className="gradient-background" style={{ paddingBottom: '30px', paddingTop: '30px' }}>
                <div className="container pt-4">
                <h4 className="mb-3 activeMembers-main-title">Sponsorship Opportunities</h4>
                    <div className="table-responsive p-5">
                        <table className="table table-bordered text-center shadow-card">
                        <thead className="table-header eligibility-label-header">
                            <tr>
                            <th>Details of Sponsorship (Inclusive of GST)</th>
                            <th>Platinum Sponsor Rs. 15,00,000/-</th>
                            <th>Diamond Sponsor Rs. 10,00,000/-</th>
                            <th>Gold Sponsor Rs. 5,00,000/-</th>
                            <th>Silver Sponsor Rs. 3,00,000/-</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Exhibition Stall</td>
                                <td>Yes</td>
                                <td>Yes</td>
                                <td>Yes</td>
                                <td>--</td>
                            </tr>
                            <tr>
                                <td>Presentation in Technical Session</td>
                                <td>Yes</td>
                                <td>Yes</td>
                                <td>--</td>
                                <td>--</td>
                            </tr>
                            <tr>
                                <td>Complementary Registration</td>
                                <td>8 Nos.</td>
                                <td>5 Nos.</td>
                                <td>3 Nos.</td>
                                <td>2 Nos.</td>
                            </tr>
                            <tr>
                                <td>Advertisement in Symposium Booklet</td>
                                <td>Full color page</td>
                                <td>Full color page</td>
                                <td>Half color page</td>
                                <td>Half color page</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <FooterComponent />
        </>
    );
};

export default SponsorshipTable;
